import { render, staticRenderFns } from "./AssessmentQuestion.vue?vue&type=template&id=e2498864&scoped=true"
import script from "./AssessmentQuestion.vue?vue&type=script&lang=js"
export * from "./AssessmentQuestion.vue?vue&type=script&lang=js"
import style0 from "./AssessmentQuestion.vue?vue&type=style&index=0&id=e2498864&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2498864",
  null
  
)

export default component.exports